'use strict';
import { AppContext } from 'plugin/liferay-widgets-react-web';
import { default as JournalWebApi } from './webapi/JournalWebApi';

//import { default as JournalEntryLoginRenderer } from './components/JournalEntryLoginRenderer';
//import { default as JournalEntryLogoutRenderer } from './components/JournalEntryLogoutRenderer';

export * from './stores/StoreFactory';

AppContext.registerBundle({
    webApis: { JournalWebApi }
});

export const JournalEntry = undefined;
//export const JournalRenderer_LOGIN = JournalEntryLoginRenderer;
//export const JournalRenderer_LOGOUT = JournalEntryLogoutRenderer;

export { JournalWebApi };

export { default as JournalListWidget } from './widgets/JournalListWidget.jsx';

export { default as JournalListItem } from './components/JournalListItem.jsx';
export { default as JournalActions } from './actions/JournalActions.js';



// WEBPACK FOOTER //
// ./js/journal-portlet.js